import styles from './Form.module.scss.js';
import { FieldMessages } from './Messages.js';
import { Required } from './Required.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Text } from '../text/Text.js';
import classNames from 'clsx';

/** Internal, do not export from index */
function InputField(props) {
  const {
    label,
    required,
    children,
    error,
    help,
    prominentHelp,
    warning,
    success,
    tag,
    tagName,
    htmlFor,
    nesting = 'child',
    showIndicator = 'optional',
    className: callerClassName,
    labelClassName: callerLabelClassName
  } = props;
  const className = classNames('dsx-component', styles['field-container'], callerClassName);
  const labelClassName = classNames(styles['field-container'], callerLabelClassName);
  const getTag = tagFactory(tagName, tag);
  const messageEls = /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(FieldMessages, {
      kind: "error",
      value: error,
      ...getTag('error')
    }), /*#__PURE__*/jsx(FieldMessages, {
      kind: "success",
      value: success,
      ...getTag('success')
    }), /*#__PURE__*/jsx(FieldMessages, {
      kind: "warning",
      value: warning,
      ...getTag('warning')
    }), /*#__PURE__*/jsx(FieldMessages, {
      kind: "prominent-help",
      value: prominentHelp,
      ...getTag('prominent-help')
    }), /*#__PURE__*/jsx(FieldMessages, {
      kind: "help",
      value: help,
      ...getTag('help')
    })]
  });
  if (nesting === 'child') {
    return /*#__PURE__*/jsxs("div", {
      ...getTag('container'),
      className: className,
      children: [/*#__PURE__*/jsxs("label", {
        className: labelClassName,
        htmlFor: htmlFor,
        children: [/*#__PURE__*/jsxs(Text, {
          variant: "label",
          element: "div",
          className: styles['label-container'],
          children: [label, /*#__PURE__*/jsx(Required, {
            required: required,
            showIndicator: showIndicator,
            ...getTag('required')
          })]
        }), children]
      }), messageEls]
    });
  }
  return /*#__PURE__*/jsxs("div", {
    ...getTag('container'),
    className: className,
    children: [/*#__PURE__*/jsx("label", {
      className: labelClassName,
      htmlFor: htmlFor,
      children: /*#__PURE__*/jsxs(Text, {
        variant: "label",
        element: "div",
        className: styles['label-container'],
        children: [label, /*#__PURE__*/jsx(Required, {
          required: required,
          showIndicator: showIndicator,
          ...getTag('required')
        })]
      })
    }), children, messageEls]
  });
}
function tagFactory(component, value) {
  return part => ({
    [`data-dsx--${component}--${part}`]: value
  });
}

export { InputField };
